import { Navigate, useParams, useRoutes } from "react-router-dom"
import { ItemPage } from "../ItemPage"
import { PhotoTourProvider } from "../providers/photoTour"
import { assertIsDefined } from "../../../utils/assetIsDefined"

const routes = [
    {
        path: `photo/item/:index`,
        element: <ItemPage />
    },
    {
        path: "/*",
        element: <Navigate to={`photo/item/0`} />
    }
]

export const CleaningTourRoutes = () => {
    const { cleaningId } = useParams<{ cleaningId: string }>()
    assertIsDefined(cleaningId)

    const element = useRoutes(routes)

    return (
        <PhotoTourProvider cleaningId={cleaningId}>{element}</PhotoTourProvider>
    )
}
